import Enumerable from "linq";

export class StringFilterParameter {
  constructor(public keyword: string = "", public isPartialMatch = true, public splitters: string[] = []) {
  }

  filter(source: string): boolean {
    return !this.keyword
      || (this.keyword === "")
      || ((this.keyword && this.keyword.trim() && this.splitters && this.splitters.length > 0)
        ? this.containsKeywords(source)
        : (this.isPartialMatch ? (0 <= source.indexOf(this.keyword)) : (source === this.keyword)));
  }

  containsKeywords(source: string): boolean {
    const keywords = Enumerable.from(this.splitters)
      .skip(1)
      .aggregate(this.keyword, (k, s) => k.replace(new RegExp(s, "g"), this.splitters[0]))
      .split(this.splitters[0]);
    return Enumerable.from(keywords).all(k => source.indexOf(k) >= 0);
  }

  clone(): StringFilterParameter {
    return new StringFilterParameter(
      this.keyword,
      this.isPartialMatch,
      this.splitters
    );
  }
}
